import { LatLng, LeafletMouseEvent, Map } from 'leaflet';
import { ReactElement, useEffect } from 'react';
import { useMap } from 'react-leaflet';

export interface IMapViewerClickHandlerProps {
	onClick: (latlng: LatLng) => void;
}

export function MapViewerClickHandler(
	props: IMapViewerClickHandlerProps
): ReactElement {
	const { onClick } = props;
	const map: Map = useMap();

	useEffect(() => {
		map.on('click', handleOnClick);

		return () => {
			map.off('click', handleOnClick);
		};
	}, []);

	function handleOnClick(event: LeafletMouseEvent): void {
		const position: LatLng = event.latlng;

		onClick(position);
	}

	return <></>;
}
